import { deleteCookie } from './cookie';

export const clearAuthUserData = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('authentication_result');
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('authentication_result');
  deleteCookie('authentication_result');
};
